'use client'

import { Link } from '@/components/Link'
import { Icon } from '../Icon'
import styles from './ShareElements.module.scss'

const ShareElements = ({ url }: { url: string }) => {
  const onCopy = () => {
    navigator.clipboard.writeText(url)
  }

  return (
    <div className={styles.elements}>
      <Link
        className={styles.btn}
        href={'https://www.facebook.com/share.php?u=' + url}
        title="Facebook"
        target="_blank"
      >
        <Icon name="facebook" size={24} className={styles.icon} />
        <div className={styles.label}>Facebook</div>
      </Link>
      <Link className={styles.btn} href={'https://twitter.com/share?url=' + url} title="X" target="_blank">
        <Icon name="x" size={24} className={styles.icon} />
        <div className={styles.label}>X</div>
      </Link>
      <div className={styles.btn} title="Link kopieren" onClick={onCopy}>
        <Icon name="link" size={24} className={styles.icon} />
        <div className={styles.label}>Link kopieren</div>
      </div>
    </div>
  )
}

export default ShareElements
